<template>

  <div class="page">

    <page-header></page-header>

    <div class="page-content">
      <div class="container pt-3 pb-3">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 white-bg pt-2 pb-2 text-small" v-html="page.impressum_text">
          </div>
        </div>

      </div>
    </div>

    <page-footer :social-media="page.social_media"></page-footer>

  </div>

</template>

<script>
  import PageHeader from "../components/PageHeader";
  import PageFooter from "../components/PageFooter";

  export default {
    name: 'Impressum',
    components: {
      PageHeader,
      PageFooter
    },
    data: function () {
      return {
        page: [],
      }
    },
    mounted() {
      this.axios
              .get('https://goodhoodmusic.com/wp-json/wp/v2/pages')
              .then((response) => {
                for (const value of response.data) {
                  if (value.id === 2) {
                    this.page = value.acf;
                  }
                }
              })
    }
  }
</script>
